export default "__VITE_ASSET__9c87b3cf__"